import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Widget } from '@uploadcare/react-widget'
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';

const Qualification = ({ data, onchange, value, route }) => {

    const navigate = useNavigate()
    const [photo, setPhoto] = useState('')
    const [signature, setSignature] = useState('')
    const [updatedList, setUpdatedList] = useState(false)
    const [studentData, setStudentData] = useState({})
    const [tenthBoard, setTenthBoard] = useState('')
    const [twelveBoard, setTwelveBoard] = useState('')
    const [gradBoard, setGradBoard] = useState('')
    const [tenthTotal, setTenthTotal] = useState('')
    const [twelveTotal, setTwelveTotal] = useState('')
    const [gradTotal, setGradTotal] = useState('')
    const [tenthObtained, setTenthObtained] = useState('')
    const [twelveObtained, setTwelveObtained] = useState('')
    const [gradObtained, setGradObtained] = useState('')
    const [checked, setChecked] = useState(false)
    const [preview, setPreview] = useState(false)
    const [optSmModal, setOptSmModal] = useState(false);
    const toggleShow = () => setOptSmModal(!optSmModal);
    const [addressProof, setAddressProof] = useState('')

    console.log('photo', photo)
    console.log('signature', signature)
    //       UPDATE PHOTO AND SIGNATURE OF USER
    async function updatePhotoSignature() {
        // event.preventDefault()

        const response = await fetch('/document-update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                userId: studentData._id,
                photo,
                signature
            })
        })
            .then((response) => response.json())
            .then((data) => {
                // console.log(data)
                if (data.message == "changes successfully") {
                    // alert('changes successfully')
                    // setCentredModal(false)
                    navigate('/fillApplication-step6')
                }
                else {
                    alert('Error')
                    // setCentredModal(false)
                }
            })
    }


    //   DOCUMENT UPLOAD THROUGH UPLOADCARE.Com

    // PHOTO

    const uploadFileChange = async (file) => {
        console.log("file change: ", file);
        const formData = new FormData(); // Create a new FormData object
        formData.append('file', file); // Append the file to the FormData object

        try {
            const response = await axios.post('/api/v2/file-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Set the content type
                },
            });
            console.log("response:", response);
            toast.success(response.data.message);
            setPhoto(response.data.data);
            onchange.setPhoto(response.data.data)

        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "An error occurred");
        }
    };
    // SIGNATURE
    const uploadFileChange2 = async (file) => {
        console.log("file change: ", file);
        const formData = new FormData(); // Create a new FormData object
        formData.append('file', file); // Append the file to the FormData object

        try {
            const response = await axios.post('/api/v2/file-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Set the content type
                },
            });
            console.log("response:", response);
            toast.success(response.data.message);
            setSignature(response.data.data);
            onchange.setSignature(response.data.data)

        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "An error occurred");
        }
    };

    const uploadAddressProof = async (file) => {
        console.log("file change: ", file);
        const formData = new FormData(); // Create a new FormData object
        formData.append('file', file); // Append the file to the FormData object

        try {
            const response = await axios.post('/api/v2/file-upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data', // Set the content type
                },
            });
            console.log("response:", response);
            toast.success(response.data.message);
            setAddressProof(response.data.data);
            onchange.setAddressProof(response.data.data)

        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || "An error occurred");
        }
    };

    const uploadFileSelect2 = (file) => {
        console.log(`file changed ${file}`)
        setUpdatedList(false)
        if (file) {
            file.progress((info) => console.log("file progress: ", info.progress))
            file.done((info) => setUpdatedList(true))
        }
    }
    useEffect(() => {
        if (data.educationDetails) {
            setPhoto(data.educationDetails.photo)
            console.log("photo........", data.photo)
            setSignature(data.educationDetails.signature)
            setGradBoard(data.educationDetails.gradBoard)
            setTenthBoard(data.educationDetails.tenthBoard)
            setTwelveBoard(data.educationDetails.twelveBoard)
            setTenthObtained(data.educationDetails.tenthObtained)
            setTwelveObtained(data.educationDetails.twelveObtained)
            setGradObtained(data.educationDetails.gradObtained)
            setTenthTotal(data.educationDetails.tenthTotal)
            setTwelveTotal(data.educationDetails.twelveTotal)
            setGradTotal(data.educationDetails.gradTotal)
            setAddressProof(data.educationDetails.addressProof)
        }
    }, [data])
    return (
        <div className="overflow-x-auto relative">
            <ToastContainer />
            <div>
                <p className='font-bold text-black'>Academic Information</p>
                <p className='font-bold text-black text-[14px]'>
                    {/* Higher Secondary Academic Details <span className='text-red-600'>*</span> */}
                </p>
                <table className='border border-black text-[14px] w-[100%] overflow-x-scroll'>
                    <thead>
                        <tr className='border border-black'>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                Qualification
                            </th>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                School/Institute name
                            </th>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                Board
                            </th>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                Result Status
                            </th>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                Year Of Passing
                            </th>
                            <th className='border pt-3 pb-3 pl-2 font-bold text-black border-black'>
                                Obtained Percentage / CGPA
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className='border text-center font-bold border-black'>
                                10th <sup><span className='text-red-600 '>*</span></sup>
                            </td>
                            <td className='border p-2 border-black'>
                                <input value={value.tenthSchool} onChange={(e) => { onchange.setTenthSchool(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' placeholder="Eg: xyz School" type="text" />
                            </td>
                            <td className='border p-2 border-black'>
                                <select
                                    value={value.tenthBoard}
                                    onChange={(e) => onchange.setTenthBoard(e.target.value)}
                                    className='border border-black w-[100%] p-[7px] outline-none bg-white'
                                >
                                    <option value="">Select 10th Exam Board</option>
                                    {
                                        data.application_type == "NRI" &&
                                        <>
                                            <option value="IB_MYP">International Baccalaureate (IB) – MYP (Middle Years Programme)</option>
                                            <option value="IGCSE_Cambridge">Cambridge IGCSE (Cambridge Assessment International Education)</option>
                                            <option value="Edexcel_IGCSE">Pearson Edexcel International GCSE</option>
                                            <option value="OxfordAQA_IGCSE">OxfordAQA International GCSE</option>
                                            <option value="CISCE_ICE">CISCE – ICE (Indian Certificate of Education, International)</option>
                                            <option value="WJEC_Eduqas">WJEC Eduqas International GCSE</option>
                                            <option value="ICBE">International Curriculum Board of Education (ICBE)</option>
                                            <option value="NCFE">NCFE International (UK Qualification Board)</option>
                                            <option value="SABIS">SABIS® International Education Board</option>

                                        </>
                                    }
                                    <option value="CBSE">Central Board of Secondary Education (CBSE)</option>
                                    <option value="ICSE"> Indian Council of Secondary Education (ICSE)</option>
                                    <option value="CISCE">Council for the Indian School Certificate Examinations (CISCE)</option>
                                    <option value="NIOS">National Institute of Open Schooling (NIOS)</option>
                                    <option value="BSEB">Bihar School Examination Board</option>
                                    <option value="MSBSHSE">Maharashtra State Board of Secondary and Higher Secondary Education</option>
                                    <option value="UPMSP">Uttar Pradesh Madhyamik Shiksha Parishad</option>
                                    <option value="RBSE">Board of Secondary Education, Rajasthan</option>
                                    <option value="GSHSEB">Gujarat Secondary and Higher Secondary Education Board</option>
                                    <option value="BSE_Odisha">Board of Secondary Education, Odisha</option>
                                    <option value="HBSE">Board of School Education, Haryana</option>
                                    <option value="HPBOSE">Himachal Pradesh Board of School Education</option>
                                    <option value="KBPE">Kerala Board of Public Examinations</option>
                                    <option value="KSEAB">Karnataka School Examination and Assessment Board</option>
                                    <option value="PSEB">Punjab School Education Board</option>
                                    <option value="WBBSE">West Bengal Board of Secondary Education</option>
                                    <option value="TBSE">Tripura Board of Secondary Education</option>
                                    <option value="NBSE">Nagaland Board of School Education</option>
                                    <option value="MBSE">Mizoram Board of School Education</option>
                                    <option value="MBOSE">Meghalaya Board of School Education</option>
                                    <option value="BSE_Assam">Board of Secondary Education, Assam</option>
                                    <option value="BSE_Manipur">Board of Secondary Education, Manipur</option>
                                    <option value="CGBSE">Chhattisgarh Board of Secondary Education</option>
                                    <option value="JAC">Jharkhand Academic Council</option>
                                    <option value="APBSE">Board of Secondary Education, Andhra Pradesh</option>
                                    <option value="BOSE_Telangana">Board of Secondary Education, Telangana</option>
                                    <option value="GBSHSE">Goa Board of Secondary and Higher Secondary Education</option>
                                    <option value="BOSE_Sikkim">Sikkim Board of Secondary Education</option>
                                    <option value="UBSE">Uttarakhand Board of School Education</option>
                                    <option value="JKBOSE">Jammu and Kashmir Board of School Education</option>
                                    <option value="BOSE_Ladakh">Ladakh Board of School Education</option>
                                    <option value="BOSE_Arunachal">Directorate of School Education, Arunachal Pradesh</option>
                                    <option value="CBSE_Andaman">Andaman and Nicobar Islands (Under CBSE)</option>
                                    <option value="CBSE_Chandigarh">Chandigarh (Under CBSE)</option>
                                    <option value="CBSE_DadraNagar">Dadra & Nagar Haveli and Daman & Diu (Under CBSE)</option>
                                    <option value="CBSE_Lakshadweep">Lakshadweep (Under CBSE)</option>
                                    <option value="CBSE_Puducherry">Puducherry (Under CBSE)</option>
                                    <option value="DSE_Delhi">Directorate of Education, Delhi (CBSE affiliated)</option>

                                    <option value="Any_Other">Any Other</option>
                                </select>
                            </td>

                            <td className='border p-2 border-black'>
                                <select value={value.tenthResultStatus} onChange={(e) => { onchange.setTenthResultStatus(e.target.value) }} name="" id="" className='border w-[100%] p-[8px] outline-none border-black'>
                                    <option value="">--Select--</option>
                                    <option value="Awaited">Awaited</option>
                                    <option value="Declared">Declared</option>
                                </select>
                            </td>
                            <td className='border  p-2 border-black'>
                                <input value={value.tenthYOP} onChange={(e) => { onchange.setTenthYOP(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                            </td>
                            <td className='border p-2 border-black'>
                                <input value={value.tenthPer} onChange={(e) => { onchange.setTenthPer(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                            </td>
                        </tr>
                        <tr>
                            <td className='border text-center font-bold border-black'>
                                12th {route == "mba" && <sup><span className='text-red-600 '>*</span></sup>}
                            </td>
                            <td className='border p-2 border-black'>
                                <input value={value.twelveSchool} onChange={(e) => { onchange.setTwelveSchool(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' placeholder="Eg:xyz School / College" type="text" />
                            </td>
                            <td className='border p-2 border-black'>
                                <select
                                    value={value.twelveBoard}
                                    onChange={(e) => onchange.setTwelveBoard(e.target.value)}
                                    className='border border-black w-[100%] p-[7px] outline-none bg-white'
                                >
                                    <option value="">Select 12th Exam Board</option>
                                    {
                                        data.application_type == "NRI" &&
                                        <>
                                            <option value="IB_DP">International Baccalaureate (IB) – Diploma Programme (DP)</option>
                                            <option value="Cambridge_International_AS_A_Level">
                                                Cambridge International AS & A Levels (CAIE)
                                            </option>
                                            <option value="Edexcel_IAL">Pearson Edexcel International A Levels (IAL)</option>
                                            <option value="OxfordAQA_IAL">OxfordAQA International A Levels</option>
                                            <option value="AP_CollegeBoard">Advanced Placement (AP), College Board (USA)</option>
                                            <option value="Caribbean_CSEC_CAPE">Caribbean Examinations Council – CAPE</option>
                                            <option value="SABIS_International">SABIS® International Education Board</option>
                                            <option value="NCFE_International">NCFE International (UK)</option>

                                        </>
                                    }
                                    <option value="CBSE">Central Board of Secondary Education (CBSE)</option>
                                    <option value="ICSE"> Indian Council of Secondary Education (ICSE)</option>
                                    <option value="CISCE">Council for the Indian School Certificate Examinations (CISCE)</option>
                                    <option value="NIOS">National Institute of Open Schooling (NIOS)</option>
                                    <option value="BSEB">Bihar School Examination Board (Intermediate)</option>
                                    <option value="MSBSHSE">Maharashtra State Board of Secondary and Higher Secondary Education</option>
                                    <option value="UPMSP">Uttar Pradesh Madhyamik Shiksha Parishad</option>
                                    <option value="RBSE">Board of Secondary Education, Rajasthan (Senior Secondary)</option>
                                    <option value="GSHSEB">Gujarat Secondary and Higher Secondary Education Board</option>
                                    <option value="CHSE_Odisha">Council of Higher Secondary Education, Odisha</option>
                                    <option value="HBSE">Board of School Education, Haryana (Senior Secondary)</option>
                                    <option value="HPBOSE">Himachal Pradesh Board of School Education (Plus Two)</option>
                                    <option value="DHSE_Kerala">Directorate of Higher Secondary Education, Kerala</option>
                                    <option value="DPUE_Karnataka">Department of Pre-University Education, Karnataka</option>
                                    <option value="PSEB">Punjab School Education Board (Senior Secondary)</option>
                                    <option value="WBCHSE">West Bengal Council of Higher Secondary Education</option>
                                    <option value="TBSE">Tripura Board of Secondary Education (Higher Secondary)</option>
                                    <option value="NBSE">Nagaland Board of School Education (Class 12)</option>
                                    <option value="MBSE">Mizoram Board of School Education (Higher Secondary)</option>
                                    <option value="MBOSE">Meghalaya Board of School Education (HSSLC)</option>
                                    <option value="COHSEM">Council of Higher Secondary Education, Manipur</option>
                                    <option value="AHSEC">Assam Higher Secondary Education Council</option>
                                    <option value="CGBSE">Chhattisgarh Board of Secondary Education (Higher Secondary)</option>
                                    <option value="JAC">Jharkhand Academic Council (Intermediate)</option>
                                    <option value="BIEAP">Board of Intermediate Education, Andhra Pradesh</option>
                                    <option value="TGBIE">Telangana State Board of Intermediate Education</option>
                                    <option value="GBSHSE">Goa Board of Secondary and Higher Secondary Education</option>
                                    <option value="SBSE_Sikkim">Sikkim Board of Secondary Education (Senior Secondary)</option>
                                    <option value="UBSE">Uttarakhand Board of School Education (Intermediate)</option>
                                    <option value="JKBOSE">Jammu and Kashmir Board of School Education</option>
                                    <option value="BOSE_Ladakh">Ladakh Board of School Education</option>
                                    <option value="BOSE_Arunachal">Directorate of School Education, Arunachal Pradesh</option>
                                    <option value="CBSE_Andaman">Andaman and Nicobar Islands (Under CBSE)</option>
                                    <option value="CBSE_Chandigarh">Chandigarh (Under CBSE)</option>
                                    <option value="CBSE_DadraNagar">Dadra & Nagar Haveli and Daman & Diu (Under CBSE)</option>
                                    <option value="CBSE_Lakshadweep">Lakshadweep (Under CBSE)</option>
                                    <option value="CBSE_Puducherry">Puducherry (Under CBSE)</option>
                                    <option value="DSE_Delhi">Directorate of Education, Delhi (CBSE affiliated)</option>

                                    <option value="Any_Other">Any Other</option>
                                </select>
                            </td>

                            <td className='border p-2 border-black'>
                                <select name="" id="" value={value.twelveResultStatus} onChange={(e) => { onchange.setTwelveResultStatus(e.target.value) }} className='border w-[100%] p-[8px] outline-none border-black'>
                                    <option value="">--Select--</option>
                                    <option value="Awaited">Awaited</option>
                                    <option value="Declared">Declared</option>
                                </select>
                            </td>
                            <td className='border p-2 border-black'>
                                <input value={value.twelveYOP} onChange={(e) => { onchange.setTwelveYOP(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                            </td>
                            <td className='border p-2 border-black'>
                                <input value={value.twelvePer} onChange={(e) => { onchange.setTwelvePer(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                            </td>
                        </tr>
                        {
                            route == 'mba' &&

                            <tr>
                                <td className='border text-center font-bold border-black'>
                                    Graduation
                                </td>
                                <td className='border p-2 border-black'>
                                    <input value={value.gradSchool} onChange={(e) => { onchange.setGradSchool(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' placeholder="Ex:xyz School / College" type="text" />
                                </td>
                                <td className='border p-2 border-black'>
                                    <input value={value.gradBoard} onChange={(e) => { onchange.setGradBoard(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-uppercase' type="text" />
                                </td>
                                <td className='border p-2 border-black'>
                                    <select name="" id="" value={value.gradResultStatus} onChange={(e) => { onchange.setGradResultStatus(e.target.value) }} className='border w-[100%] p-[8px] outline-none border-black'>
                                        <option value="">--Select--</option>
                                        <option value="Awaited">Awaited</option>
                                        <option value="Declared">Declared</option>
                                    </select>
                                </td>
                                <td className='border p-2 border-black'>
                                    <input value={value.gradYOP} onChange={(e) => { onchange.setGradYOP(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                                </td>
                                <td className='border p-2 border-black'>
                                    <input value={value.gradPer} onChange={(e) => { onchange.setGradPer(e.target.value) }} className='border border-black w-[100%] p-[7px] outline-none text-capitalize' type="text" />
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="grid sm:flex justify-between mt-4" style={{ width: '100%' }}>
                <div className="col-md-5 gap-2">
                    <div>
                        <p className="text-[14px] text-black font-bold">Upload Your Recent Passport Size Photograph <sup className="text-red-600 text-[16px]">*</sup></p>
                        <div className="mt-[-10px] border border-black text-black p-1 flex items-center justify-start">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => uploadFileChange(e.target.files[0])}
                                className=""
                                id="photo-upload"
                            />
                           
                        </div>
                        <span className="text-[12px] text-blue-600">Max Upload Limit 100 KB</span>
                    </div>
                    {photo && (
                        <div>
                            <img
                                style={{ width: '150px', height: '150px', margin: 'auto', marginTop: '1rem' }}
                                className="border border-black p-2"
                                src={photo}
                                alt="photo"
                            />
                        </div>
                    )}
                </div>
                <div className="col-md-5 gap-4">
                    <div>
                        <p className="text-[14px] text-black font-bold">Upload Your Signature <sup className="text-red-600 text-[16px]">*</sup></p>
                        <div className="mt-[-10px] border border-black text-black p-1 flex items-center justify-start">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => uploadFileChange2(e.target.files[0])}
                                className=""
                                id="signature-upload"
                            />
                        </div>
                        <span className="text-[12px] text-blue-600">Max Upload Limit 50 KB</span>
                    </div>
                    {signature && (
                        <div style={{ width: '150px', height: '150px', margin: 'auto', verticalAlign: 'center', marginTop: '1rem' }} className="border border-black">
                            <img
                                style={{ width: '150px', height: '150px', margin: 'auto' }}
                                src={signature}
                                alt="Uploaded Signature"
                            />
                        </div>
                    )}
                </div>
            </div>
            {
                data.application_type == "NRI" &&
                <div className="col-md-5 gap-4">
                    <div>
                        <p className="text-[12px] text-black font-bold flex items-center mt-5"><p>Residential proof, proof of age, and nationality documents such as passport, birth certificate, or national ID.</p>
                            <sup className="text-red-600 text-[16px]">*</sup></p>
                        <div className="mt-[-10px] border border-black text-black p-1 flex items-center justify-start">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => uploadAddressProof(e.target.files[0])}
                                className=""
                                id="Address-proof-upload"
                            />
                        </div>
                        <span className="text-[12px] text-blue-600">Max Upload Limit 50 KB</span>
                    </div>
                    {addressProof && (
                        <div style={{ width: '150px', height: '150px', margin: 'auto', verticalAlign: 'center', marginTop: '1rem' }} className="border border-black">
                            <img
                                style={{ width: '150px', height: '150px', margin: 'auto' }}
                                src={addressProof}
                                alt="Uploaded Signature"
                            />
                        </div>
                    )}
                </div>
            }

        </div>
    )
}

export default Qualification